<h2 mat-dialog-title>Aggiornamento Privacy e Termini di Servizio</h2>

<mat-dialog-content>
  <p>Abbiamo aggiornato i nostri documenti legali. Per continuare devi prenderne visione e accetarli.</p>

  <form [formGroup]="form">
    <div *ngIf="form.contains('privacy')">
      <mat-checkbox disableRipple color="primary" formControlName="privacy">
        Ho letto e accetto la nuova <span [style.color]="'#ff9666'" (click)="download(2, $event)">Informativa Privacy</span>
      </mat-checkbox>
      <div [style.min-height.px]="24.5">
        <mat-error *ngIf="form.get('privacy').hasError('required') && form.get('privacy').touched" [style.font-size.px]="12">
          Accetta la nuova Informativa Privacy
        </mat-error>
      </div>
    </div>
    <div *ngIf="form.contains('terms')">
      <mat-checkbox disableRipple color="primary" formControlName="terms">
        Ho letto e accetto i nuovi <span [style.color]="'#ff9666'" (click)="download(1, $event)">Termini e Condizioni</span>
      </mat-checkbox>
      <div [style.min-height.px]="24.5">
        <mat-error *ngIf="form.get('terms').hasError('required') && form.get('terms').touched" [style.font-size.px]="12">
          Accetta i nuovi Termini e Condizioni
        </mat-error>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button [disabled]="loading" (click)="logout()">Logout</button>
  <button *ngIf="!loading" mat-button (click)="confirm()">Accetta</button>
  <div *ngIf="loading" class="d-flex align-items-center justify-content-center" style="width: 80px; height: 36px">
    <app-loader></app-loader>
  </div>
</mat-dialog-actions>
